import { APIDescriptor } from "../../types";

const baseUrl: string = "/products/beyond-compliance/api-reference";

const descriptors: APIDescriptor[] = [
    {
        name: "Custodial Wallet Provider APIs",
        description: "Data capture and reporting of Custodial Wallet Provider activity",
        path: "/virtual-assets/custodial-wallet-provider",
        categories: [ { label: "Virtual Assets" } ]
    },
    {
        name: "Exchange APIs",
        description: "Data capture and reporting of Exchange activity",
        path: "/virtual-assets/exchange",
        categories: [ { label: "Virtual Assets" } ]
    },
    {
        name: "Stablecoin Issuer APIs",
        description: "Data capture and reporting of Issuer activity",
        path: "/virtual-assets/issuer",
        categories: [ { label: "Virtual Assets" } ]
    },
    {
        name: "Payment Service Provider APIs",
        description: "Data capture and reporting of Payment Service Provider activity",
        path: "/virtual-assets/payment-service-provider",
        categories: [ { label: "Virtual Assets" } ]
    },
    {
        name: "Lending APIs",
        description: " Loan application and lifecycle reporting",
        path: "/microlending",
        categories: [ { label: "Traditional finance" } ]
    },
    {
        name: "Crowdfunding Compliance APIs",
        description: "Crowdfunding campaign and investment reporting",
        path: "/crowdfunding",
        categories: [ { label: "Traditional finance" } ]
    },
    {
        name: "Payment Service APIs",
        description: "Payment transaction and device reporting",
        path: "/payment-service",
        categories: [ { label: "Traditional finance" } ]
    },
    {
        name: "Cross Border APIs",
        description: "Cross-border money transfer reporting",
        path: "/remittance",
        categories: [ { label: "Traditional finance" } ]
    },
    {
        name: "Transaction Data APIs",
        description: "Data capture and reporting of transaction data",
        path: "/transaction-reporting",
        categories: [ { label: "Traditional finance" } ]
    }
]

export const apiDescriptors = descriptors.map((desc) => ({ ...desc, path: baseUrl + desc.path }))
